import { ConsentContext } from '@context/ConsentProvider/ConsentProvider'
import { useContext, useCallback } from 'react'
import TagManager from 'react-gtm-module'
import { useLocation } from 'react-router-dom'

const skippableSEOEventRoutes = ['payment-finished', 'paid-order']

export const useSendGTMEvent = () => {
    const permissions = useContext(ConsentContext)
    const { pathname } = useLocation()

    const sendPageViewEvent = useCallback(() => {
        if (permissions.allowGoogleTag) {
            if (skippableSEOEventRoutes.some((route) => pathname.includes(route))) return
            TagManager.dataLayer({
                dataLayer: {
                    event: 'pageview',
                    page: pathname
                }
            })
        }
    }, [permissions.allowGoogleTag, pathname])

    const sendCarpayPaymentSuccessEvent = useCallback(() => {
        if (permissions.allowGoogleTag) {
            TagManager.dataLayer({
                dataLayer: {
                    event: 'pp_success_page-view',
                    page: pathname
                }
            })
        }
    }, [permissions.allowGoogleTag, pathname])

    const sendButtonClickEvent = useCallback(
        (buttonId: string) => {
            if (permissions.allowGoogleTag) {
                TagManager.dataLayer({
                    dataLayer: {
                        event: 'button_click',
                        button_id: buttonId,
                        page: pathname
                    }
                })
            }
        },
        [permissions.allowGoogleTag, pathname]
    )

    return {
        sendPageViewEvent,
        sendCarpayPaymentSuccessEvent,
        sendButtonClickEvent
    }
}
